import { AuthProvider } from "@/features/authentication/AuthProvider";
import { Toast } from "@heroui/react";
import { Outlet, ScrollRestoration } from "react-router";

export const App = () => {
    return (
        <AuthProvider>
            <ScrollRestoration />
            <Outlet />
            {/* Lifted above the sticky save bar (h-20 mobile / h-16 desktop). */}
            <Toast.Provider placement="bottom" className="bottom-24 sm:bottom-20" />
        </AuthProvider>
    );
};
